import { render, staticRenderFns } from "./InboxItems.vue?vue&type=template&id=70ab993a"
import script from "./InboxItems.vue?vue&type=script&lang=js"
export * from "./InboxItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports